import { render, staticRenderFns } from "./StorageStatusBadge.vue?vue&type=template&id=e8dd2b8e&"
import script from "./StorageStatusBadge.vue?vue&type=script&lang=js&"
export * from "./StorageStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports